import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the MFA phone-verification popup is shown
 * Event: dental_portal:mfa:pop_up_viewed
 */
export function fireMfaPopUpViewed(): void {
  PosthogService.getInstance().track('dental_portal:mfa:pop_up_viewed');
}
